
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/booking_pages",
      function () {
        return require("private-next-pages/[publicId]/booking_pages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/booking_pages"])
      });
    }
  